// Album envelopes are sync metadata; their individual images arrive separately.
// Do not hide generic unsupported messages or actual media.
export function isAlbumPlaceholder(message: any): boolean {
 const payload = message?.waba_payload;
 return payload?.type === 'unsupported' &&
  (payload.unsupported?.type === 'album' || payload.unsupported?.raw_type === 'album');
}
